import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as editCustomerActionCreators from '@makemydeal/dr-dash-store/actions/editCustomerActionCreators';
import * as vehicleActionCreators from '@makemydeal/dr-dash-store/actions/vehicleActionCreators';
import * as vehicleProtectionActionCreators from '@makemydeal/dr-dash-store/actions/vehicleProtectionActionCreators';
import { BUYER, CO_BUYER, GAP, GAP_PRODUCT_CATEGORY_CODE, TRADE_IN, VEHICLE_ENTITY } from '@makemydeal/dr-shared-types';
import type { FsEntityKey } from '@makemydeal/dr-dash-store/types/fsSyncFailure';

export type FsEntity = FsEntityKey;

export const FS_FEES_ENTITY = 'fees';
export const FS_PROTECTION_ENTITY = 'protection';
export const FS_RATE_ENTITY = 'rate';
export const FS_TAXES_ENTITY = 'taxes';
export const FS_UNROUTED_ENTITY = 'other';

export type FsEntitySlideoutResolver = (entity: FsEntity, canonicalField?: string) => (() => void) | undefined;

export const useFsEntitySlideout = (): FsEntitySlideoutResolver => {
    const dispatch = useDispatch();

    return useCallback(
        (entity: FsEntity, canonicalField?: string) => {
            switch (entity) {
                case BUYER:
                    return () => dispatch(editCustomerActionCreators.showEditBuyerSlideout());
                case CO_BUYER:
                    return () => dispatch(editCustomerActionCreators.showEditCoBuyerSlideout());
                case VEHICLE_ENTITY:
                    return () => dispatch(vehicleActionCreators.showEditVehicle());
                case TRADE_IN:
                    return () => dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.TradeIn));
                case FS_TAXES_ENTITY:
                    return () => dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Taxes));
                case FS_FEES_ENTITY:
                    return () => dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Fees));
                case FS_RATE_ENTITY:
                    return () => dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Lender));
                case FS_PROTECTION_ENTITY:
                    return () => {
                        dispatch(baseDealActionCreators.openSlideOut(baseDealActionCreators.SlideOutType.Protection));
                        if (canonicalField === GAP) {
                            dispatch(vehicleProtectionActionCreators.setEditableVppProductCode(GAP_PRODUCT_CATEGORY_CODE));
                        }
                    };
                default:
                    return undefined;
            }
        },
        [dispatch]
    );
};
